export default __webpack_public_path__ + "static/media/remove_red_eye.ff914af3.svg";